module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/teJdaC/tc-custom/9781641086875.jpg?1717864812309",
      "alt": "This image is the cover for the book Season's Meetings"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Season's Meetings\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Shy web designer Kyle Zigler is resigned to living a solitary life as a single dad raising two gifted kids…until a sexy artist at a holiday market gives him a gift with delightful and unexpected consequences. Is he brave enough to open his heart again?"), _c('br'), _c('br'), _vm._v(" Charming holiday vendor Vic Burgess has spent his entire life on the move, drifting wherever the wind blows to sell his handmade creations, when he meets a hunky young father who makes him feel like staying put. What will it take to make him stay?"), _c('br'), _c('br'), _vm._v(" Two lonely lives colliding at Christmas…. Can a festive fling turn into something more? Find out in this heartwarming story of gay apparel, found family, and the magic of unexpected meetings.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ren Gold\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Ren Gold is a proud New Englander with a love of brown bread, Cumberland Farms, and snowstorms. An academic librarian by day, and a romance scribbler by night, Ren's life revolves around books. She's often found at estate sales looking to grow her collection of vintage romance novels which fills two rooms of her (mostly) renovated farmhouse. Ren uses her long evening walks to plan the love lives of the sexy men in her imagination.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Dreamspinner Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0